/**
 * Format a value that is already expressed in percentage points.
 *
 * This helper intentionally does not scale fractions: callers remain
 * responsible for preserving the metric's existing unit conversion.
 */
export const formatPercentage = (
  value?: number | null,
  fallback = 'N/A'
): string => {
  if (typeof value !== 'number' || !Number.isFinite(value)) return fallback;

  const rounded = Number(value.toFixed(2));
  return `${rounded.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  })}%`;
};
